var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-loader"},[_c('VIcon',{attrs:{"size":_vm.size,"color":"grey"}},[_vm._v(" mdi-loading mdi-spin ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }